import React, { memo, useCallback, useMemo } from "react";
import { NodeProps } from "reactflow";
import { NodeData, NodeType } from "../../../models/nodeType";
import { useForm } from "react-hook-form";
import { FormControl, FormLabel, Input, Text } from "@chakra-ui/react";
import { FlowNodeWithChildren } from "./FlowNode";
import { useUpdateNodeData } from "../../../hooks/useUpdateNodeData";

interface SpawnEntityNodeData extends NodeData {
  objectName: string;
}

const SpawnEntityNode: React.FC<NodeProps<NodeType<SpawnEntityNodeData>>> = (props) => {
  const {
    id: nodeId,
    data: { color, nodeData },
  } = props;

  const objectName = nodeData?.objectName ?? "";

  const { register, handleSubmit } = useForm<SpawnEntityNodeData>({
    defaultValues: useMemo(
      () => ({
        objectName,
      }),
      [objectName]
    ),
    mode: "onBlur",
  });

  const { updateNodeData } = useUpdateNodeData(nodeId);

  const handleUpdate = useCallback(
    ({ objectName }: SpawnEntityNodeData) => {
      updateNodeData({
        objectName,
      });
    },
    [updateNodeData]
  );

  return (
    <FlowNodeWithChildren {...props}>
      <form className={"nodrag"} onSubmit={handleSubmit(handleUpdate)} onBlur={handleSubmit(handleUpdate)}>
        <FormControl>
          <FormLabel>
            <Text color={color} casing={"uppercase"}>
              Object Name
            </Text>
          </FormLabel>
          <Input color={color} {...register("objectName")} />
        </FormControl>
      </form>
    </FlowNodeWithChildren>
  );
};

export default memo(SpawnEntityNode);
